import { ComponentRef, Injectable } from '@angular/core';
import { IOrderCheckoutResultDialogService } from 'projects/shared/lib/interfaces/services/dialogs/checkout-result-dialog.service.abstract';
import { OrderDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { DialogBaseService } from 'projects/shared/lib/services/ui/dialog.service';
import { OrderCheckoutResultDialogComponent } from '../../components/shared/checkout/order/result-dialog/order-checkout-result-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OrderCheckoutResultDialogService implements IOrderCheckoutResultDialogService {

  orderCheckoutResultDialogShow(
    callbackClose: () => void,
    orderList: OrderDto[] | undefined,
  ) {
    DialogBaseService.dialogGenericShow(
      OrderCheckoutResultDialogComponent,
      (component: ComponentRef<OrderCheckoutResultDialogComponent>) => {
        component.instance.modalClose.subscribe(
          () => {
            callbackClose();
            DialogBaseService.dynamicComponentRemove(component);
          }
        );
        component.instance.orderList = orderList;
      }
    );
  }

}
